import React from "react"
import {
  Input,
  Label,
  LabelWrapper,
  FieldError,
  LabelOptional,
} from "../styles"

const InputField = ({ name, label, register, required, error, ...rest }) => (
  <LabelWrapper>
    <Label>
      {label} {!required && <LabelOptional>optional</LabelOptional>}
    </Label>
    <Input className='form-input' {...register(name, { required })} {...rest} />
    {error && <FieldError>{error}</FieldError>}
  </LabelWrapper>
)

export default InputField
